import React from 'react';

let TopTab = (props) => {
  let col = props.col;
  return(
    <div id="toptab">{
      col.map((key, i) => {
        return(
          <div key={i}>{key}</div>
        )
      })
    }</div>
  )

}

export default TopTab;


// WEBPACK FOOTER //
// ./src/Containers/Nav/TopTab.js